// Components
import LoginPage from '../../features/Welcome/Login';

const Login = () => {
  return <LoginPage />;
};

export default Login;